import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const CGV = () => {
  return (
    <div className="py-14 sm:py-18 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 
          className="text-4xl sm:text-5xl font-bold text-[#2B2B2B] mb-8"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}
        >
          Conditions Générales de Vente
        </h1>
        
        <Card className="border-slate-200/70">
          <CardContent className="p-8 sm:p-12 prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">1. Présentation du service</h2>
              <p className="text-slate-700 leading-relaxed">
                Le site <strong>Rénovation de Salle de Bains</strong> est édité et exploité par <strong>Homely Solutions</strong>.
                Nous proposons des services de rénovation de salle de bains en Suisse romande, incluant rénovation complète,
                rénovation partielle, carrelage & revêtements, installation de sanitaires et plans 3D.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">2. Devis et commande</h2>
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">2.1. Demande de devis</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Toute demande de devis effectuée via notre formulaire en ligne est gratuite et sans engagement.
                Nous nous engageons à vous répondre sous 48 heures ouvrables.
              </p>
              
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">2.2. Devis</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Le devis fourni est valable pour une durée de 30 jours à compter de sa date d'émission.
                Il détaille les prestations proposées, les matériaux, les délais et le prix total.
              </p>
              
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">2.3. Acceptation</h3>
              <p className="text-slate-700 leading-relaxed">
                La commande est confirmée après signature du devis par le client et versement de l'acompte.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">3. Prix et paiement</h2>
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">3.1. Prix</h3>
              <p className="text-slate-700 leading-relaxed mb-4">
                Les prix sont indiqués en francs suisses (CHF), toutes taxes comprises (TTC).
                Ils comprennent les matériaux, la main d'œuvre et les frais de déplacement dans la zone d'intervention.
              </p>
              
              <h3 className="text-xl font-semibold text-[#2B2B2B] mb-2">3.2. Modalités de paiement</h3>
              <ul className="list-disc list-inside text-slate-700 space-y-2">
                <li>Acompte de 30% à la signature du devis</li>
                <li>40% à mi-parcours des travaux</li>
                <li>Solde de 30% à la livraison et après réception des travaux</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">4. Délais de réalisation</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Les délais de réalisation sont indiqués à titre indicatif dans le devis.
                Nous mettons tout en œuvre pour respecter ces délais, mais ils peuvent être ajustés en cas de force majeure
                ou de modifications demandées par le client.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">5. Garanties</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Tous nos travaux sont garantis conformément à la législation suisse en vigueur.
                La garantie couvre les défauts de matériaux et de main d'œuvre pour une durée spécifiée dans le devis.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">6. Responsabilités</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Homely Solutions s'engage à réaliser les travaux dans les règles de l'art.
                Notre responsabilité est limitée au montant des prestations réalisées.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">7. Annulation et modification</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Toute annulation ou modification importante doit être communiquée par écrit.
                En cas d'annulation après le début des travaux, les frais engagés restent dus.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">8. Données personnelles</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                Les données collectées via le formulaire de devis sont utilisées uniquement pour traiter votre demande
                et ne sont jamais partagées avec des tiers. Conformément à la législation suisse sur la protection des données,
                vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">9. Litiges</h2>
              <p className="text-slate-700 leading-relaxed mb-4">
                En cas de litige, nous privilégions une solution amiable.
                À défaut, les tribunaux suisses seront compétents.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2B2B2B] mb-4">10. Contact</h2>
              <p className="text-slate-700 leading-relaxed">
                Pour toute question concernant nos conditions générales de vente, vous pouvez nous contacter
                via notre formulaire de devis ou consulter notre page à propos.
              </p>
            </section>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <p className="text-sm text-slate-500">
                Dernière mise à jour : Mars 2026<br />
                <strong>Homely Solutions</strong> - Suisse
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CGV;